const customAmountInput = $('#custom-amount-input');
const customAmountRadio = $('#custom-amount');
const customAmountRadioLabel = $("label[for='custom-amount']");
const customAmountRow = $('#custom-amount-row');
const radioButtons = $('.ogc-radios');
const radiosLabel = $('#ogc-radios-label');

const handleCustomAmountInput = () => {
  // passed from the smarty tpl with as presetAmountsSize = '{$gift_card_presets|@count}';
  const amount = customAmountInput.val() as string;
  customAmountRadio.attr('value', amount);

  if (parseInt(window.presetAmountsSize, 10) !== 0) {
    radioButtons.css({ display: 'flex' });
  } else {
    radioButtons.css({ display: 'none' });
    customAmountRadio.css({ display: 'none' });
    customAmountRadioLabel.css({ display: 'none' });
    radioButtons.css({ display: 'none' });
    radiosLabel.css({ display: 'none' });
    customAmountRow.css({ display: 'inline-block' });
  }
  if (!customAmountRadio.is(':checked')) {
    customAmountRow.css({ display: 'none' });
    customAmountInput.val('');
    customAmountRadio.attr('value', '');
  }
};

$(() => {
  $('input[name=amount]:first').prop('checked', true);
  handleCustomAmountInput();

  customAmountRadio.on('click', () => {
    customAmountRow.css({ display: 'inline-block' });
    handleCustomAmountInput();
    $('input[name="amount"]').on('click', () => {
      handleCustomAmountInput();
    });
  });

  $('form#form-register-omni-gift-card').on('change', () => {
    handleCustomAmountInput();
  });
});
